@let agreement = $agreement();
<unity-card-agreement-summary-shared [agreement]="agreement">
  <h4>Remaining Allocation Budget</h4>
  <h3>
    @if ($isLoading()) {
      <kendo-skeleton [width]="30" />
    } @else {
      {{ agreement?.remaining_client_allocation_amount | currency }}
    }
  </h3>
  <kendo-gridlayout gap="0.5rem" [cols]="['1fr', '1em', '1fr']" [align]="{ horizontal: 'center', vertical: 'bottom' }">
    <kendo-gridlayout-item class="k-justify-self-end">
      <div class="k-text-center">
        <h6>Program Budget</h6>
        <h6>
          @if ($isLoading()) {
            <kendo-skeleton [width]="30" />
          } @else {
            {{ agreement?.client_share_of_award_amount | currency }}
          }
        </h6>
      </div>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item>
      <h6>-</h6>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item class="k-justify-self-start">
      <div class="k-text-center">
        <h6>Allocated Amount</h6>
        <h6>
          @if ($isLoading()) {
            <kendo-skeleton [width]="30" />
          } @else {
            {{ agreement?.total_client_allocated_amount | currency }}
          }
        </h6>
      </div>
    </kendo-gridlayout-item>
  </kendo-gridlayout>
</unity-card-agreement-summary-shared>
